import { IModuleParams } from "~/types";
import { getApi } from "./api";

export default ({ baseUrl }: NonNullable<IModuleParams["apiConfig"]>) => {
  return getApi(baseUrl);
};
